import clsx from 'clsx';
import useLayoutAreaStyles from './styles';
import { LayoutAreaProps } from './types';
import { useMemo } from 'react';

const LayoutArea: React.FunctionComponent<LayoutAreaProps> = (props) => {
  const classes = useLayoutAreaStyles(props);
  const { children, index, selectedArea, onClick } = props;
  const selected = useMemo(() => {
    return index === selectedArea;
  }, [index, selectedArea]);
  const renderLayoutArea = () => {
    return (
      <div
        className={clsx(classes.area, selected && classes.selected)}
        data-testid={`ghostInspectorTarget_Layout_${index}`}
        onClick={onClick}
      >
        {children}
      </div>
    );
  };

  return renderLayoutArea();
};

export default LayoutArea;
